import { Alert24Regular, OpenRegular } from "@fluentui/react-icons";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
import PageEnum from "../../../enum/PageEnum";
import { CommonHelper } from "../../../utils/common/CommonHelper";
import { useHeaderStyles } from "./styles";

export interface NotificationsHeaderProps {
  title?: string;
  notificationCount?: number;
}

const NotificationsHeader: React.FC<NotificationsHeaderProps> = ({
  title = "Notifications",
  notificationCount,
}) => {
  const styles = useHeaderStyles();
  const location = useLocation();

  const isInTeams = CommonHelper.isInTeams();
  const isNotificationsPage = location.pathname.startsWith(
    `/${PageEnum.PageUrl.Notifications}`
  );

  const notificationsLink = isNotificationsPage ? null : isInTeams ? (
    <Link
      to={`/${PageEnum.PageUrl.Notifications}`}
      aria-label="Notification Logs"
      className={styles.logsLink}
    >
      Notification Logs
      <OpenRegular />
    </Link>
  ) : (
    <Link
      to={`/${PageEnum.PageUrl.Notifications}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Notification Logs"
      className={styles.logsLink}
    >
      Notification Logs
      <OpenRegular />
    </Link>
  );

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        {<Alert24Regular aria-hidden />}
        <span className={styles.headerTitle}>
          {title}
          {notificationCount !== undefined && ` (${notificationCount})`}
        </span>
      </div>

      {notificationsLink}
    </header>
  );
};

export default NotificationsHeader;
